(function () {
  if (window.mclSec) return;
  var S = {};
  window.mclSec = S;
  var pubsub = function () { return typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined'; };
  var cartUrl = function () { return (window.routes && routes.cart_url) || '/cart'; };

  S.add = async function (variantId, quantity, source) {
    if (window.mcl && typeof window.mcl.add === 'function') return window.mcl.add(variantId, quantity, source);
    var cart = document.querySelector('cart-drawer');
    var cfg = typeof fetchConfig === 'function' ? fetchConfig('javascript') : { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' } };
    var addUrl = (window.routes && routes.cart_add_url) || '/cart/add';
    if (!cart || typeof cart.renderContents !== 'function') {
      var r = await fetch(addUrl, Object.assign({}, cfg, { body: JSON.stringify({ items: [{ id: variantId, quantity: quantity }] }) }));
      var s = await r.json();
      if (!s.status) window.location.href = cartUrl();
      return s;
    }
    var body = { items: [{ id: variantId, quantity: quantity }], sections: cart.getSectionsToRender().map(function (x) { return x.id; }), sections_url: window.location.pathname };
    var response = await fetch(addUrl, Object.assign({}, cfg, { body: JSON.stringify(body) }));
    var state = await response.json();
    if (state.status) return state;
    if (!state.key && state.items && state.items[0]) state.key = state.items[0].key;
    if (pubsub()) publish(PUB_SUB_EVENTS.cartUpdate, { source: source, productVariantId: variantId, cartData: state });
    cart.renderContents(state);
    cart.classList.remove('is-empty');
    var inner = cart.querySelector('.drawer__inner');
    if (inner) inner.classList.remove('is-empty');
    S.contar();
    return state;
  };

  S.destinoCompra = function () {
    return document.querySelector('[id^="mcl-packs-"]') || document.querySelector('.mcl-of') || document.querySelector('form[id^="product-form-"]');
  };

  S.contar = function () {
    var els = document.querySelectorAll('[data-mcl-count]');
    if (!els.length) return;
    fetch(cartUrl() + '.js', { headers: { Accept: 'application/json' } }).then(function (r) { return r.json(); }).then(function (c) {
      els.forEach(function (el) { el.textContent = c.item_count; el.hidden = !c.item_count; });
    }).catch(function () {});
  };

  S.track = function (el, evento, variantId, qty) {
    if (!el || el.dataset.mclTracking !== 'true') return;
    var ok = !window.Shopify || !Shopify.customerPrivacy || typeof Shopify.customerPrivacy.analyticsProcessingAllowed !== 'function' || Shopify.customerPrivacy.analyticsProcessingAllowed();
    if (!ok) return;
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({ event: evento, variant_id: variantId, quantity: qty, value: (Number(el.dataset.mclPrecio || 0) * qty) / 100, currency: (window.Shopify && Shopify.currency && Shopify.currency.active) || 'EUR' });
  };

  document.addEventListener('click', async function (e) {
    var b = e.target.closest('[data-mcl-accion]');
    if (b) {
      var acc = b.dataset.mclAccion;
      var vid = Number(b.dataset.mclVariante || 0);
      if (acc === 'url') return;
      e.preventDefault();
      if (acc === 'scroll' || !vid) {
        var d = S.destinoCompra();
        if (d) d.scrollIntoView({ behavior: 'smooth', block: 'center' });
        else if (b.dataset.mclFallback) window.location.href = b.dataset.mclFallback;
        return;
      }
      if (acc === 'checkout') {
        S.track(b, 'mcl_initiate_checkout', vid, 1);
        window.location.href = cartUrl() + '/' + vid + ':1';
        return;
      }
      b.setAttribute('aria-busy', 'true');
      try {
        var st = await S.add(vid, 1, 'mcl-seccion');
        if (!(st && st.status)) S.track(b, 'mcl_add_to_cart', vid, 1);
      } catch (err) {} finally { b.removeAttribute('aria-busy'); }
      return;
    }
    var carro = e.target.closest('[data-mcl-carrito]');
    if (carro) {
      var drawer = document.querySelector('cart-drawer');
      if (drawer && typeof drawer.open === 'function') { e.preventDefault(); drawer.open(carro); }
      return;
    }
    var abrir = e.target.closest('[data-mcl-menu-abrir]');
    if (abrir) {
      var m = document.getElementById(abrir.getAttribute('aria-controls'));
      if (m) { m.classList.add('is-open'); m.setAttribute('aria-hidden', 'false'); abrir.setAttribute('aria-expanded', 'true'); S.menuBtn = abrir; var c = m.querySelector('[data-mcl-menu-cerrar]'); if (c) c.focus(); }
      return;
    }
    var cerrar = e.target.closest('[data-mcl-menu-cerrar]');
    if (cerrar) S.cerrarMenu(cerrar.closest('.mcl-menu'));
  });

  S.cerrarMenu = function (m) {
    if (!m) return;
    m.classList.remove('is-open');
    m.setAttribute('aria-hidden', 'true');
    if (S.menuBtn) { S.menuBtn.setAttribute('aria-expanded', 'false'); S.menuBtn.focus(); }
  };
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') S.cerrarMenu(document.querySelector('.mcl-menu.is-open'));
  });

  var iniciar = function () {
    S.contar();
    if (pubsub()) subscribe(PUB_SUB_EVENTS.cartUpdate, function () { setTimeout(S.contar, 300); });

    if ('IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (en) {
          var v = en.target;
          if (en.isIntersecting) { var p = v.play(); if (p && p.catch) p.catch(function () {}); } else v.pause();
        });
      }, { threshold: 0.5 });
      document.querySelectorAll('video[data-mcl-auto]').forEach(function (v) { io.observe(v); });
    }

    document.querySelectorAll('[data-mcl-una]').forEach(function (w) {
      w.addEventListener('toggle', function (e) {
        if (!e.target.open) return;
        w.querySelectorAll('details[open]').forEach(function (d) { if (d !== e.target) d.open = false; });
      }, true);
    });

    var barra = document.querySelector('[data-mcl-barra]');
    if (barra) {
      var obj = document.querySelector('[data-mcl-cta-principal]') || document.querySelector('.mcl-of .mcl-packs__btn') || document.querySelector('.product-form__submit');
      var mostrar = function (v) { barra.classList.toggle('visible', v); barra.setAttribute('aria-hidden', String(!v)); };
      if (obj && 'IntersectionObserver' in window) {
        new IntersectionObserver(function (es) { var e0 = es[0]; mostrar(!e0.isIntersecting && e0.boundingClientRect.top < 0); }, { threshold: 0 }).observe(obj);
      } else {
        var um = Number(barra.dataset.umbral || 1.2);
        window.addEventListener('scroll', function () { mostrar(window.scrollY > um * window.innerHeight); }, { passive: true });
      }
      var dr = document.querySelector('cart-drawer');
      if (dr) new MutationObserver(function () { barra.classList.toggle('drawer-abierto', dr.classList.contains('active')); }).observe(dr, { attributes: true, attributeFilter: ['class'] });
    }
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', iniciar, { once: true });
  else iniciar();
})();
